<template>
  <a-layout-sider
    :class="['sider', 'shadow', theme,]"
    :width="hideRight?'90px':'250px'"
    :collapsible="collapsible"
    :trigger="null">
    <div class="cm-box">
      <div class="left-box">
        <div v-for="(item,index) in menuData"
             :key="index"
             :class="[index===selectedIndex?'sel-left-item':'def-left-item']"
             @click="selectGroup(index,item)">
          <span>
              <a-icon :type="item.meta.icon" :style="{'color': index===selectedIndex?'#FAAD14':'white'}"/>
              <span :class="[index===selectedIndex?'sel-title':'def-title']"
                    style="cursor:pointer;margin-left: 10px">{{ item.meta.title }}</span>
          </span>

        </div>
      </div>
      <div class="right-menu" v-if="!hideRight">
        <custom-group-menu :data-list="childrenData"></custom-group-menu>
      </div>
    </div>
  </a-layout-sider>
</template>

<script>
import CustomGroupMenu from '../CustomGroupMenu/CustomGroupMenu'
import { mixin, mixinDevice } from '@/utils/mixin'

export default {
  name: 'SideMenu',
  components: { CustomGroupMenu },
  mixins: [mixin, mixinDevice],
  props: {
    menus: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      selectedIndex: -1,
      menuData: [],
      childrenData: [],
      hideRight: false
    }
  },
  watch: {
    menus: function(value) {
      this.menuData = this.getShowDataList(value)
    },
    $route: function() {
      this.updateMenu()
    }
  },
  mounted() {
    this.menuData = this.getShowDataList(this.menus)
    this.updateMenu()
  },
  methods: {
    updateMenu() {
      const routes = this.$route.matched.concat()
      const path = routes[routes.length - 1].path
      const index = this.getIndexByPath(path, this.menuData)
      if (this.selectedIndex !== index) {
        this.selectGroup(index)
      }
    },
    onSelect(obj) {
      this.$emit('menuSelect', obj)
    },
    getIndexByPath(path, list) {
      for (let i = 0, len = list.length; i < len; i++) {
        let item = list[i]
        if (path === item.path) {
          return i
        } else if (item.children && item.children.length > 0) {
          let searchIndex = this.getIndexByPath(path, item.children)
          if (searchIndex >= 0) {
            return i
          }
        }
      }
      return -1
    },
    selectGroup(index, item) {
      if (this.menuData.length > index) {
        this.selectedIndex = index
        this.childrenData = item ? item.children : this.menuData[index].children
        this.hideRight = this.menuData[index].hideChildren || this.childrenData.length < 1
        let showRoute = this.getFirstSelectedChildRoute(item)
        if (showRoute && (showRoute.redirect || showRoute.path)) {
          const path = showRoute.redirect ? showRoute.redirect : showRoute.path
          let lastRoute = this.$route.matched[this.$route.matched.length - 1]
          if (lastRoute.path !== path) {
            this.$router.push({ path: path })
          }
        }
      }
    },
    getFirstSelectedChildRoute(route) {
      if (route && route.children && route.children.length > 0) {
        for (let i = 0, len = route.children.length; i < len; i++) {
          if (!route.hidden && (!route.children[i].children || route.children[i].children.length < 1)) {
            return route.children[i]
          } else {
            return this.getFirstSelectedChildRoute(route.children[i])
          }
        }
      }
      return route
    },

    getShowDataList(list) {
      const newList = []
      if (list && list.length > 0) {
        list.forEach((item, i, a) => {
          if (!item.hidden && item.children && item.children.length > 0 && !item.hideChildrenInMenu) {
            item.children = this.sortChildren(item.children)
            newList.push(item)
          }
        })
      }
      return newList
    },
    //排序，没有隐藏的在前面
    sortChildren(children) {
      if (children && children.length > 0) {
        const newChildren = children.sort((a, b) => {
          if (a.hidden === b.hidden) {
            return 0
          }
          if (a.hidden) {
            return 1
          }
          return -1
        })
        newChildren.forEach(child => {
          child.children = this.sortChildren(child.children)
        })
        return newChildren
      }
      return children
    }
  }
}
</script>
<style>
.cm-box {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.left-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 90px;
  height: 100%;
  max-height: calc(100% - 60px);
  //background-color: #4A4A4A;
  background-color: #002140;
  opacity: 0.96;
  overflow: scroll;
}

.def-left-item {
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
}

.sel-left-item {
  background-color: white;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
}

.icon {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

.def-title {
  color: white;
}

.sel-title {
  color: #FAAD14;
  font-weight: 650;
}

.right-menu {
  position: absolute;
  top: 0;
  right: 0;
  width: 160px;
  height: 100%;
  background-color: white;
  box-sizing: border-box;
  padding-left: 30px;
  overflow: scroll;
  max-height: calc(100% - 60px);
}
</style>
